module.exports = __webpack_public_path__ + "static/media/favicon.5f6e87ff.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.ico
// module id = 599
// module chunks = 20